"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get2DVectorToRectDistance = exports.get2DVectorDistance = void 0;
const get2DVectorDistance = (x1, y1, x2, y2) => Math.sqrt(Math.abs(x1 - x2) ** 2 + Math.abs(y1 - y2) ** 2);
exports.get2DVectorDistance = get2DVectorDistance;
const get2DVectorToRectDistance = (pX, pY, rectX, rectY, rectWidth, rectHeight) => Math.sqrt(Math.max(rectX - pX, 0, pX - (rectX + rectWidth)) ** 2
    + Math.max(rectY - pY, 0, pY - (rectY + rectHeight)) ** 2);
exports.get2DVectorToRectDistance = get2DVectorToRectDistance;
